export const ROLES = {
    0: "ADMIN",
    2: "OPERAIO",
    3: "RESPONSABILE"
}